import * as React from "react";
import Box from "@mui/material/Box";
import inbookLogo from "../../assets/myinbook.png"

const HomeHeader = () => {
  return (
    <img src={inbookLogo} alt='MyInBook' width='360px' height='100px' className='logo-box' style={{marginTop: "-50px"}}/>
  );
};

export default HomeHeader;
